import { SocialChartData } from '@/modules/statistics/social/hooks/use-social-data.ts'
import { TotalDataOption } from '@/modules/statistics/social/ui/SidebarChartLegend.tsx'

export function mapChartDataToViewsLegendData(
  chartData: SocialChartData | undefined,
) {
  if (!chartData) return { data: [] }

  const data = chartData.views.datasets[0].data.map((value, index) => {
    const label = chartData?.views?.labels?.at(index) || ''

    return {
      name: label,
      value,
    }
  }) as TotalDataOption[]

  return {
    data,
  }
}

export function mapChartDataToFollowersLegendData(
  chartData: SocialChartData | undefined,
) {
  if (!chartData) return { data: [] }

  const data = chartData.followers.datasets[0].data.map((value, index) => {
    const label = chartData?.followers?.labels?.at(index) || ''

    return {
      name: label,
      value,
    }
  }) as TotalDataOption[]

  return {
    data,
  }
}
